/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 1 = RateLimit 2 = Log 3 = Challenge
 */
export type RatelimitRuleActionType = 1 | 2 | 3;

export const RatelimitRuleActionType = {
  RateLimit: 1 as RatelimitRuleActionType,
  Log: 2 as RatelimitRuleActionType,
  Challenge: 3 as RatelimitRuleActionType,
};
